import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// Bootstrap Scoped
// The div parent class needed to use this style is .bootstrap-scope but this is
// already included in index.html by default
import './css/bootstrap-4.1.1-scoped.min.css'
import './css/index.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('privacy_form_root')
)
